<template>
    <div>
        <b-input-group class="mb-3">
            <b-form-input
                id="current-date"
                v-model="formatted_current_date"
                type="text"
                placeholder="Date à définir"
                autocomplete="off"
                disabled
                class="bg-white"
            ></b-form-input>
            <b-input-group-append>
                <b-form-datepicker
                    v-model="form.current_date"
                    button-only
                    right
                    label-no-date-selected="Date à définir"
                    label-prev-year="Année précédente"
                    label-next-year="Année prochaine"
                    label-prev-month="Mois précédent"
                    label-next-month="Mois prochain"
                    label-current-month="Mois actuel"
                    label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                    start-weekday="1"
                    aria-controls="current-date"
                    locale="fr"
                    @context="formatCurrentDate"
                >
                </b-form-datepicker>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'InputDateSelect',

    data() {
        return {
            form: {},
            formatted_current_date: '',
        }
    },

    computed: {
        ...mapState({
            activityDate: (state) => state.timeSheetsVM.currentDate,
        }),
    },

    mounted() {
        this.form.current_date = this.activityDate
    },

    methods: {
        formatCurrentDate(ctx) {
            this.$store.commit('timeSheetsVM/RESET_ERROR')
            this.formatted_current_date = ctx.selectedFormatted
            this.$store.commit(
                'timeSheetsVM/SET_CURRENT_DATE',
                this.form.current_date
            )
            this.$parent.getData()
        },
    },
}
</script>

<style scoped></style>
